import type { ZoneAPIError, ZoneAPIResponse } from '../types';

export const zoneStore = defineStore('zoneStore', () => {
  const zoneResponse = ref<ZoneAPIResponse | null>(null);
  const zoneError = ref<ZoneAPIError | null>(null);
  const maxDepth = ref<number>(2);
  const loading = ref<boolean>(false);

  const setZoneResponse = (data: ZoneAPIResponse | null): void => {
    zoneResponse.value = data;
  };
  const setZoneError = (error: ZoneAPIError | null): void => {
    zoneError.value = error;
  };
  const setMaxDepth = (data: number): void => {
    maxDepth.value = data;
  };
  const setLoading = (data: boolean): void => {
    loading.value = data;
  };

  return {
    zoneResponse,
    zoneError,
    maxDepth,
    loading,
    setZoneResponse,
    setZoneError,
    setMaxDepth,
    setLoading,
  };
});
